import { FC, useContext, useState } from "react"
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { FcCancel } from 'react-icons/fc'
import { launchSimulation } from "../../../services/scenario-service";
import { error, success } from "../../../utils/notifications";
import { catchResponse } from "../../../utils/helperFunctions";
import { UserContext } from "../../../Redux/UserContext";
import { FiCommand } from "react-icons/fi";
import { VISUALIZACION_PERMISSIONS } from "../../../data/constants";
import { ProgressBar } from 'primereact/progressbar';
import { MdRocketLaunch } from "react-icons/md";
import gif_launch from '../../../assets/images/cohete.gif'
import gif_error from '../../../assets/images/explosion-nuclear.gif'
import gif_success from '../../../assets/images/bandera.gif'

export const LaunchSimulationModal:FC<any> = (props):JSX.Element => {

    const { visible, setVisible, numberQueuedSimulations, setNumberQueuedSimulations , launchError, setLaunchError, launchSuccess, setLaunchSuccess ,scenarioId } = props

    const [state] = useContext(UserContext)

    const [loadingChangeName, setLoadingChangeName] = useState<boolean>(false)

    const handleCloseLaunchSimulationModal = () => {
        setVisible(false)
        setNumberQueuedSimulations(undefined)
        setLaunchError(false)
        setLaunchSuccess(false)
    }

    const handleQueueSimulation = async() => {
        try {
            setLoadingChangeName(true)
            
            let body = {
                id_scenario: parseInt(scenarioId)
            }
            try {
                const res = await launchSimulation(body)
                const { code, message} = res.data
                if(code === 200) {
                    setLoadingChangeName(false)
                    handleCloseLaunchSimulationModal()
                    success(message)
                } else if(code === 300) {
                    setLoadingChangeName(false)
                    handleCloseLaunchSimulationModal()
                    success("Simulación puesta en cola correctamente")
                 } else {
                    setLoadingChangeName(false)
                    handleCloseLaunchSimulationModal()
                    error("Error poniendo en cola la simulación")
                }
            } catch(err:any){
                setLoadingChangeName(false)
                handleCloseLaunchSimulationModal()
                catchResponse(err)
            }
                    
        } catch(err:any) {
            catchResponse(err)
        }
    }


    const headerContent = (
        <div className="changename-header">
            {
                launchError?
                    <span>¡Se ha producido un error!</span>
                :
                launchSuccess?
                    <span>¡Simulación iniciada!</span>
                :
                numberQueuedSimulations === undefined?
                    <span>Identificando...</span>
                :
                numberQueuedSimulations < 2?
                    <span>Lanzando simulación...</span>
                :
                    <span>Simulaciones en espera</span>
            }

        </div>
    )

    const footerContent = (
        <div className="changename-footer">
            {   
                numberQueuedSimulations === undefined?
                <div style={{minHeight:45}}>
                </div>

                :

                numberQueuedSimulations < 2?
                <div style={{minHeight:45}}>
                </div>
                :
                < >
                    <Button severity={'danger'} label="Cancelar" icon={<FcCancel style={{fontSize:20,marginRight:5}} />} onClick={handleCloseLaunchSimulationModal}  outlined />
                    <Button severity={'success'} label="Continuar" icon={loadingChangeName? <FiCommand className="loading-icon" style={{fontSize:20,marginRight:5}} /> :<MdRocketLaunch style={{fontSize:20,marginRight:5}} />} disabled={state?.rol_id !== undefined? !VISUALIZACION_PERMISSIONS.U.includes(state?.rol_id) || loadingChangeName : false} onClick={handleQueueSimulation}  outlined />
                </>
            }
            
        </div>
    );


    return (
        <div className="card flex justify-content-center">
            <Dialog header={headerContent} visible={visible} style={{ width: '40vw' }} onHide={handleCloseLaunchSimulationModal} footer={footerContent}>
                {
                    numberQueuedSimulations === undefined?
                    <div className="changename-modal-container" style={{border:'none'}}>
                        <ProgressBar mode="indeterminate" style={{ height: '6px' }}></ProgressBar>
                    </div>
                    :
                    numberQueuedSimulations < 2?
                    <div className="changename-modal-container" style={{border:'none'}}>
                        {/*<FiCommand className="loading-icon" style={{fontSize:60,color:'var(--lis-dark)',opacity:0.6}}  />*/}
                        {
                            launchError?
                                <>
                                <img src={gif_error} style={{fontSize:30}} alt="GIF" />
                                <span>jaja</span>
                                </>
                                
                            :
                            launchSuccess?
                                <img src={gif_success} style={{fontSize:30}} alt="GIF" />
                            :
                                <img src={gif_launch} style={{fontSize:30}} alt="GIF" />
                        }
                        
                    </div>
                    :
                    <div className="changename-modal-container">
                        <span style={{textAlign:'center',fontFamily:'var(--roboto-medium)',fontSize:'1rem'}}>
                            En este momento hay un total 2 simulaciones en curso, con lo cual, esta simulación se pondrá en cola en la {numberQueuedSimulations - 1}º posición y se ejecutará cuando llegue su turno.
                        </span>
                        <span style={{textAlign:'center',fontFamily:'var(--roboto-medium)',fontSize:'1rem'}}>¿Continuar?</span>
                    </div>
                }
                
            </Dialog>
        </div>
    )
}